module.exports = __webpack_public_path__ + "img/chevron_circle_down.2972d8cb.svg";